import {
    useTranslate,
    IResourceComponentsProps,
    CrudFilters,
    // useExport,
    // useNavigation,
    // useDelete,
    HttpError,
    getDefaultFilter,
  
} from "@pankod/refine-core";

import {
    List,
    Table,
    // TextField,
    useTable,
    // getDefaultSortOrder,
    DateField,
    // Popover,
    Card,
    Input,
    Icons,
    Form,
    DatePicker,
    Select,
    Space,
    // EditButton,
    DeleteButton,
    ShowButton,
    // NumberField,
    useSelect,
    Button,
    FormProps,
    Row,
    Col,
    SelectProps,
    // ExportButton,
} from "@pankod/refine-antd";

import { OrderStatus } from "components/salesStatus";

import dayjs from "dayjs";

// import { OrderStatus, OrderActions } from "components";

import { ISale, ISalesFilterVariables, IStore, IOrganization } from "interfaces";
// import { ISalesSource, ISalesSourceFilterVariables, IOrder, IStore, IOrderFilterVariables } from "interfaces";
import { useMemo } from "react";

export const SalesList: React.FC<IResourceComponentsProps> = () => {
  // const { tableProps, sorter, searchFormProps, filters } = useTable<
  const { tableProps, searchFormProps, filters } = useTable<
      ISale,
      HttpError,
      ISalesFilterVariables
    >({
      initialSorter: [{
        field: "created_at",
        order: "desc",
      }],
      metaData: {
        select: "id, title, created_at, status, code, store_id, sales_date, organization_id, deleted_file, organizations!sales_organization_id_fkey(id,title,debug), stores!sales_store_id_fkey(id,title)",
        // select: "id, title, created_at, status, code, store_id, sales_date, organization_id, deleted_file, organizations!sales_organization_id_fkey(id,title,debug), stores:store_id(id,title)",
      },
      onSearch: (params) => { 
        const filters: CrudFilters = [];
        const { q, store, organization, sales_date, status } = params;
        console.log("params", params);

        filters.push({
          field: "title",
          operator: "contains",
          value: q,
        });

        filters.push({
          field: "store_id",
          operator: "eq",
          value: store,
        });

        filters.push({
          field: "organization_id",
          operator: "eq",
          value: organization,
        });

        filters.push({
          field: "status",
          operator: "eq",
          value: status,
        });

          if (sales_date) {
              filters.push(
                  {
                      field: "sales_date",
                      operator: "gte",
                      value: sales_date
                          ? sales_date[0].startOf("day").toISOString()
                          : undefined,
                  },
                  {
                      field: "sales_date",
                      operator: "lte",
                      value: sales_date
                          ? sales_date[1].endOf("day").toISOString()
                          : undefined,
                  },
              );
          }

        return filters;
      },
    });

    const t = useTranslate();
    // const { show } = useNavigation();
  // const { mutate: mutateDelete} = useDelete<ISale>();

    // const { isLoading, triggerExport } = useExport<IOrder>({
    //     sorter,
    //     filters,
    //     pageSize: 50,
    //     maxItemCount: 50,
    //     mapData: (item) => {
    //         return {
    //             id: item.id,
    //             amount: item.amount,
    //             orderNumber: item.orderNumber,
    //             status: item.status.text,
    //             store: item.store.title,
    //             user: item.user.firstName,
    //         };
    //     },
    // });

    // const Actions: React.FC = () => (
    //     <ExportButton onClick={triggerExport} loading={isLoading} />
    // );

    // const handleDelete = (id: number) => {
    //     // mutateDeleteMany({
    //     //   resource: "orders",
    //     //   ids: [id],
    //     // });
    //     mutateDelete({
    //       resource: "sales",
    //       id: id,
    //     });
    // };
  // console.log(tableProps);
  
  return (
    <Row gutter={[16, 16]}>
      <Col xl={6} lg={24} xs={24}>
        <Card bordered={false} title={t("filter.filters")}>
          <Filter
            formProps={searchFormProps}
            filters={filters || []}
          />
        </Card>
      </Col>
      <Col xl={18} xs={24}>
        <List
          // pageHeaderProps={{
          //     extra: <Actions />,
          // }}
        >
          <Table
            {...tableProps}
            rowKey="id"
            // onRow={(record) => {
            //   return {
            //     onClick: () => {
            //       show("sales", record.id);
            //     },
            //   };
            // }}
          >
          <Table.Column
            key="title"
            dataIndex="title"
            title={t("sales.fields.title")}
            sorter
          />
          <Table.Column
            dataIndex="status"
            title={t("sales.fields.status")}
            render={(value) => {
              return <OrderStatus status={value} />;
            }}
            // defaultSortOrder={getDefaultSortOrder(
            //     "status.text",
            //     sorter,
            // )}
            sorter
          />
          <Table.Column
            dataIndex="sales_date"
            title={t("sales.fields.salesDate")}
            render={(value) => (
                <DateField value={value} format="LL" />
            )}
            sorter
          />
          <Table.Column
            dataIndex="created_at"
            title={t("sales.fields.createdAt")}
            render={(value) => (
                (!value || value === "0001-01-01") ?  <Space/> : <DateField value={value} format="LLL" />
            )}
            sorter
          />
          <Table.Column<ISale>
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <ShowButton
                  hideText
                  size="small"
                  recordItemId={record.id}
                />
                <DeleteButton
                  // disabled={(record.status === "Cancelled") ? true : false}
                  disabled={(record.status === "Cancelled" && record.organizations?.debug === true) ? false: true}
                  hideText
                  size="small"
                  // onClick={() => handleDelete(record.id)}
                  recordItemId={record.id}
                />
              </Space>
            )}
          />
          </Table>
        </List>
      </Col>
    </Row>
  );
};

const Filter: React.FC<{ formProps: FormProps; filters: CrudFilters }> = (
    props,
  ) => {
    const t = useTranslate();

    const { formProps, filters } = props;
    const { selectProps: storeSelectProps } = useSelect<IStore>({
      resource: "stores",
      defaultValue: getDefaultFilter("store.id", filters),
    });

    // const { selectProps: orderSelectProps } = useSelect<IStore>({
    //   resource: "orderStatuses",
    //   optionLabel: "text",
    //   optionValue: "text",
    //   defaultValue: getDefaultFilter("status", filters),
    // });

    const { selectProps: organizationSelectProps } = useSelect<IOrganization>({
      resource: "organizations",
      // optionLabel: "title",
      defaultValue: getDefaultFilter("organizations.id", filters),
    });

    const { RangePicker } = DatePicker;

    const salesDate = useMemo(() => {
      const start = getDefaultFilter("sales_date", filters, "gte");
      const end = getDefaultFilter("sales_date", filters, "lte");

      const startFrom = dayjs(start);
      const endAt = dayjs(end);

      if (start && end) {
        return [startFrom, endAt];
      }
      return undefined;
    }, [filters]);

    const tr = "On The Way";
    const optionOrderStatuses: SelectProps['options'] = [
      { value: "Pending", label: t("enum.orderStatuses.Pending") },
      { value: "Ready", label: t("enum.orderStatuses.Ready") },
      { value: "On The Way", label: t(`enum.orderStatuses.${tr}`) },
      { value: "Delivered", label: t("enum.orderStatuses.Delivered") },
      { value: "Cancelled", label: t("enum.orderStatuses.Cancelled") },
    ];

    // const handleChange = (value: string[]) => {
    //   console.log(`selected ${value}`);
    // };


    return (
      <Form
        layout="vertical"
        {...formProps}
        initialValues={{
          q: getDefaultFilter("title", filters),
          store: getDefaultFilter("store.id", filters),
          organizations: getDefaultFilter("organizations.id", filters),
          status: getDefaultFilter("status", filters, "in"),
          salesDate,
        }}
      >
        <Row gutter={[10, 0]} align="bottom">
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item label={t("orders.filter.search.label")} name="q">
              <Input
                placeholder={t("sales.filter.search.placeholder")}
                prefix={<Icons.SearchOutlined />}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item
              label={t("orders.filter.status.label")}
              name="status"
            >
              <Select
                options={optionOrderStatuses}
                // {...OptionsOrderStatuses}
                allowClear
                // onChange={handleChange}
                placeholder={t("orders.filter.status.placeholder")}
              />
            </Form.Item>
          </Col>
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item
              label={t("orders.filter.organization.label")}
              name="organization"
            >
              <Select
                {...organizationSelectProps}
                allowClear
                // mode="multiple"
                placeholder={t("orders.filter.organization.placeholder")}
              />
            </Form.Item>
          </Col>
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item
                label={t("orders.filter.store.label")}
                name="store"
                    >
                <Select
                  {...storeSelectProps}
                  allowClear
                  placeholder={t("orders.filter.store.placeholder")}
                />
              </Form.Item>
            </Col> 
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item
                label={t("orders.filter.salesDate.label")}
                name="sales_date"
              >
                <RangePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  block
                >
                  {t("orders.filter.submit")}
                </Button>
              </Form.Item>
            </Col>
          </Row>
      </Form>
    );
};